import React from "react";
import { ListItem, ListItemText } from "@mui/material";

const NavigationDrawerItem = ({ label, sx = {}, ...props }) => (
  <ListItem button sx={sx} {...props}>
    <ListItemText primary={label} />
  </ListItem>
);

export default NavigationDrawerItem;
